var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateFiledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83342 0.978516C5.27065 0.978516 5.6251 1.33297 5.6251 1.7702V2.56188H10.3752V1.7702C10.3752 1.33297 10.7296 0.978516 11.1669 0.978516C11.6041 0.978516 11.9586 1.33297 11.9586 1.7702V2.56188C13.7075 2.56188 15.1253 3.97968 15.1253 5.72862V12.8538C15.1253 14.6027 13.7075 16.0205 11.9586 16.0205H4.04174C2.29279 16.0205 0.875 14.6027 0.875 12.8538V5.72862C0.875 3.97968 2.29279 2.56188 4.04174 2.56188V1.7702C4.04174 1.33297 4.39619 0.978516 4.83342 0.978516ZM10.5392 7.34595C10.8483 7.6551 10.8483 8.1564 10.5392 8.46555L7.76827 11.2364C7.61983 11.3849 7.41843 11.4683 7.20847 11.4683C6.99852 11.4683 6.79711 11.3849 6.64867 11.2364L5.46114 10.0489C5.15197 9.73976 5.15197 9.23847 5.46114 8.92932C5.77031 8.62016 6.27158 8.62016 6.58074 8.92932L7.20847 9.55704L9.41956 7.34595C9.72872 7.03677 10.23 7.03677 10.5392 7.34595Z",
    fill: "#151918",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateFiledIcon);
export default __webpack_public_path__ + "static/media/DateFiledIcon.de845d84974d0d5e4eccc93dc8e66e95.svg";
export { ForwardRef as ReactComponent };